/** =========================================================
 * Maintenance Events controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-maintenance-events')
    .controller('MaintenanceEventsController', MaintenanceEventsController);

  MaintenanceEventsController.$inject = [
    '$rootScope',
    '$scope',
    '$state',
    '$stateParams',
    '$translate',
    '$api',
    'MainPreloader',
    'ngDialog'
  ];

  function MaintenanceEventsController(
    $rootScope,
    $scope,
    $state,
    $stateParams,
    $translate,
    $api,
    MainPreloader,
    ngDialog
  ) {
    var vm = this;

    vm.pageTitle = $state.current.title;
    vm.pageSubTitle = $state.current.subTitle;
    vm.init = false;

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    // //////////////

    function activate() {
      vm.init = true;

      vm.tableConfig = {
        model: 'maintenance_event',
        getDataParams: {
          order: {
            id: 'desc'
          },
          with: ['start_user', 'end_user', 'maintenance.workgroup'],
          getAttrs: ['status']
        },
        filters: angular.copy($stateParams.filters),
        resources: ['maintenance', 'user'],
        fields: [{
          title: 'Status',
          key: 'status',
          customType: 'html',
          value: function (item) {
            return '<span class="label label-' + item.status + '">' + $translate.instant($rootScope.appConfig.types.status_types[item.status]) + '</span>';
          },
          sort: true
        }, {
          title: 'Title',
          key: null,
          value: function (item) {
            return item.maintenance.name;
          }
        }, {
          title: 'Workgroup',
          key: null,
          value: function (item) {
            return item.maintenance.workgroup.name;
          }
        }, {
          title: 'Deadline',
          key: 'deadline',
          customType: 'dateTime',
          order: true
        }, {
          title: 'User',
          key: 'start_user_id',
          value: function (item) {
            if (item.end_user_id !== null) {
              return item.end_user.name;
            } else if (item.start_user_id !== null) {
              return item.start_user.name;
            }

            return '';
          },
          order: true
        }],
        add: {
          permission: $rootScope.helpers.hasPermissionTo('maintenance edit'),
          template: 'app/views/dialogs/item-maintenance-event.html'
        },
        edit: {
          permission: $rootScope.helpers.hasPermissionTo('maintenance edit'),
          template: 'app/views/dialogs/item-maintenance-event.html',
          except: ['status', 'start_user', 'end_user', 'maintenance']
        },
        delete: {},
        customButtons: [{
          permission: $rootScope.helpers.hasPermissionTo('maintenance_event view'),
          title: 'Comment',
          icon: 'fa fa-comment-o',
          class: 'btn-info',
          visible: function (item) {
            return item.comment ? true : false;
          },
          action: function (item) {
            try {
              var dialogScope = $scope.$new(true);

              dialogScope.item = angular.copy(item);

              ngDialog.openConfirm({
                template: 'app/views/dialogs/maintenance-event-comment.html',
                scope: dialogScope
              });
            } catch (error) {
              Raven.captureException(error);
            }
          }
        }, {
          permission: $rootScope.helpers.hasPermissionTo('maintenance_event edit'),
          title: 'Start',
          icon: 'icon-control-play',
          class: 'btn-default',
          visible: function (item) {
            try {
              return item.start === null && item.end === null;
            } catch (error) {
              Raven.captureException(error);
            }

            return false;
          },
          action: function (item) {
            try {
              var dialogScope = $scope.$new(true);

              dialogScope.message = $translate.instant('Do you want to start?');
              dialogScope.title = item.maintenance.name;
              dialogScope.description = item.maintenance.description;

              ngDialog.openConfirm({
                template: 'app/views/dialogs/confirm.html',
                scope: dialogScope
              }).then(function () {
                MainPreloader.show();

                $api.update({
                  model: 'maintenance_event',
                  data: {
                    id: item.id,
                    start: true
                  }
                }).then(MainPreloader.hide, MainPreloader.hide);
              });
            } catch (error) {
              MainPreloader.hide();

              Raven.captureException(error);
            }
          }
        }, {
          permission: $rootScope.helpers.hasPermissionTo('maintenance_event edit'),
          title: 'Finish',
          icon: 'icon-like',
          class: 'btn-success',
          visible: function (item) {
            try {
              return item.start !== null && item.end === null && item.start_user_id === $rootScope.appConfig.user.id;
            } catch (error) {
              Raven.captureException(error);
            }

            return false;
          },
          action: function (item) {
            try {
              var dialogScope = $scope.$new(true);

              dialogScope.item = angular.copy(item);

              ngDialog.openConfirm({
                template: 'app/views/dialogs/maintenance-event-finish.html',
                scope: dialogScope
              }).then(function () {
                MainPreloader.show();

                $api.update({
                  model: 'maintenance_event',
                  data: {
                    id: item.id,
                    end: true,
                    comment: dialogScope.item.comment
                  }
                }).then(MainPreloader.hide, MainPreloader.hide);
              });
            } catch (error) {
              MainPreloader.hide();

              Raven.captureException(error);
            }
          }
        }]
      };

      vm.tableConfig.getData = function () {
        try {
          return $rootScope.helpers.defaultGetData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      };

      vm.tableConfig.getData();

      $rootScope.helpers.initActiveTableConfig(vm.tableConfig);
    }
  }
})();
